/**
 * Lead Observability Event Names
 *
 * These constants define the event names tracked for lead request observability.
 * Used with NewRelic Browser APM for monitoring tour/contact/info form failures.
 */

/**
 * Event tracked when lead submission fails
 */
export const LEAD_REQUEST_FAILURE = 'lead_request_failure' as const;
